export const isBuilderEditing = query => {
  return query.__builder_editing__;
};
